import { AppState } from './../../../interfaces/app-state.interface';
import { TrInputComponent } from './../tr-input/tr-input.component';
import { Component, OnInit } from '@angular/core';
import { Input } from '@angular/core';
import { Store } from '@ngrx/store';

@Component({
    selector: "tr-radio",
    templateUrl: "./tr-radio.component.html",
    styleUrls: ["./tr-radio.component.scss"],
})
export class TrRadioComponent extends TrInputComponent implements OnInit {
    @Input("radios") public radioValues: object[];
    @Input("tip") public tip: string;
    @Input("inline") public inline: boolean = false;
    @Input("ignoreValue") public ignoreValue: any[] = [];

    constructor(store: Store<AppState>) {
        super(store);
    }

    public ngOnInit() {
        this.ControlReference.valueChanges.subscribe((data) => {
            if (this.ignoreValue.indexOf(data) >= 0) {
                this.ControlReference.setValue(null);
            }
        });
    }

    public changeValue(value) {
        if (this.ignoreValue.indexOf(value) >= 0) {
            this.ControlReference.setValue(null);
        } else {
            this.ControlReference.setValue(value);
        }
    }
}
